import React, { Component, Fragment } from "react";
import { inject, observer } from 'mobx-react';
import { AgGridReact } from "ag-grid-react";
import classnames from "classnames";
import { Button, FormGroup, Input, Label, Table, Modal, ModalFooter, ModalHeader, ModalBody } from "reactstrap";
import { Plus, Edit, Trash, Check, Search } from "react-feather";
import 'ag-grid-community/dist/styles/ag-grid.css';
import 'ag-grid-community/dist/styles/ag-theme-material.css';


@inject('listSettingsStore')
@observer
class Lists extends Component {
  constructor(props) {
    super(props);
    this.state = {
      ListsOverlayVisible: false,
      selectedListItem: {},
      isEditable: false,
      deleteModal: false,
      rowData: [],
      columnDefs: [
        { headerName: "Option Name", field: "name", editable: true },
        { headerName: "Option Value", field: "value", editable: true, cellStyle: { borderRight: "1px solid #cacaca", borderLeft: "1px solid #cacaca" } },
        { headerName: "Display Order", field: "displayOrder", editable: true },
      ],
      defaultColDef: {
        flex: 1,
        cellEditor: 'agTextCellEditor'
      },
      getRowHeight: 100,
      isFullWidthCell: 100 ,
    };
  }

  componentDidMount = () => {
    const { listSettingsStore } = this.props;
    listSettingsStore.getLists();
  }

  onChange = event => {
    const { listSettingsStore } = this.props;
    let value = event.target.value;
    if (event.target.name === "name" || "code") {
      listSettingsStore.setAttribute(event.target.name, value);
    }
  };

  onGridReady = params => {
    this.gridApi = params.api;
    this.gridColumnApi = params.columnApi;
  };

  handleSave = () => {
    const { listSettingsStore } = this.props;
    listSettingsStore.saveList();
    this.toggleOverlay(false);
  }

  // toogle method will take 3 params -> toggle: bool, new/edit: string, data: any
  toggleOverlay = (toggle, action = "", data = false) => {
    const { listSettingsStore } = this.props;
    if (toggle) {
      if (action === "new") {
        listSettingsStore.setBlankList();
        this.setState({
          rowData: [],
          selectedListItem: listSettingsStore.list
        })
      }
      if (action === "edit" && data) {
        listSettingsStore.setList(data);
      }
    }
    this.setState({
      isEditable: action === "edit" ? true: false,
      ListsOverlayVisible: toggle
    });
  }

  updateOptions = (item) => {
    let temp = [];
    if(item.options && item.options.length) {
      temp = item.options.map((item) => {
        return(
          {
            name: item.name,
            value: item.value,
            displayOrder: item.displayOrder
          }
        )
      })
    }
    this.setState({
      selectedListItem: item,
      rowData: temp
    }, ()=>{
      this.toggleOverlay(true, 'edit', item);
    })
  }

  saveData = () => {
    const {selectedListItem} = this.state;
    const newOptions = [];
    this.gridApi.forEachNode((node, index) => {
      return(
        newOptions.push(node.data)
      )
    })
    selectedListItem.options = newOptions;
    this.props.listSettingsStore.saveList(selectedListItem);
    this.toggleOverlay(false);
  }

  addNewRow = () => {
    const { rowData } = this.state;
    rowData.unshift({
      name: "",
      value: "",
      displayOrder: "0"
    })
    this.gridApi.setRowData(rowData);
  }

  remove = (uid) => {
    this.setState({
      deleteModal: true,
      currentObjId: uid
    })
  }

  deleteEntry = () => {
    const { listSettingsStore } = this.props;
    listSettingsStore.deleteList(this.state.currentObjId);
    this.setState({
      deleteModal: false
    })
  }

  render() {
    const { listSettingsStore } = this.props;
    const { selectedListItem, isEditable } = this.state;
    const { lists, list } = listSettingsStore;
    const { name } = listSettingsStore.list;
    return (
      <Fragment>
        <div className="topbar">
          <FormGroup className="position-relative mb-0" style={{width: "30%"}}>
            <Input
              className="w-100 mr-1 mb-sm-0 search-product"
              type="text"
              placeholder="search..."
              value={this.state.searchVal}
            />
            <div className="form-control-position">
              <Search size={22} />
            </div>
          </FormGroup>
          <Button
            color="primary"
            className="btn"
            onClick={()=>this.toggleOverlay(true, 'new')}
          >
            <Plus size={18} />Add New
          </Button>
        </div>
        <div>
         {
           lists && lists.length
              ? <Table hover>
                <thead>
                  <tr>
                    <th>Name</th>
                    <th>List Code</th>
                    <th>Count</th>
                    <th>Last Updated</th>
                    <th className="text-center">Action</th>
                  </tr>
                </thead>
                <tbody>
                  {
                    lists.map((item, index) => {
                      return (
                        <Fragment>
                          {
                            item.visible
                            ?<tr key={item.uid}>
                              <td>{item.name}</td>
                              <td>{item.listCode}</td>
                              <td>{item.options.length}</td>
                              <td>{item.lastUpdatedOn}</td>
                              <td className="text-center">
                                {
                                  item.editable
                                    ? <Edit size={16} className="mr-1" onClick={() => this.updateOptions(item)} />
                                    :  null
                                }
                                {
                                  item.deletable
                                  ? <Trash size={16} color="#dc3545" onClick={() => this.remove(item.uid)} />
                                  : null
                                }        
                              </td>
                            </tr>
                            : null
                          }
                        </Fragment>                        
                      );
                    })
                  }
                </tbody>
              </Table>
            : null
         }
        </div>
        <div className="animation-slider">
          {
            this.state.ListsOverlayVisible
                ? <Fragment>
                  <div className="animation-slider-sidebar" style={{ width: "60vw" }}>
                    <div className="sidebar_header">
                    <span className="heading">
                      { isEditable ? "Edit List" : "Add List" }
                    </span>
                    <div>
                      <Button
                        className="btn mr-1"
                        disabled={selectedListItem.name ? false : true}
                        onClick={this.saveData}
                        color="primary">
                         Save
                        </Button>
                      <Button
                        className="btn ml-1"
                        outline
                        color="danger"
                        onClick={()=>this.toggleOverlay(false)}
                      >
                        Cancel
                        </Button>
                    </div>
                  </div>
                  <div className="sidebar_content">
                    <div className="mb-2">
                      <FormGroup>
                        <Label>List Name</Label>
                        <Input
                          type="text"
                          name="name"
                          placeholder="List Name"
                          value={ list.name ? list.name : ""}
                          onChange={e => this.onChange(e)}
                        />                      
                      </FormGroup>
                      <FormGroup>
                        <Label>List Code</Label>
                        <Input
                          type="text"
                          name="code"
                          placeholder="List Code"
                          disabled={isEditable ? true : false}
                          value={list.code}
                          onChange={e => this.onChange(e)}
                        />
                      </FormGroup>
                    </div>
                    <div>
                      <Button
                        className="btn"
                        outline
                        onClick={()=>{this.addNewRow()}}
                        color="primary"
                      >
                        <Plus size={18} />
                        Add New
                      </Button>
                    </div>
                    <div className="ag-theme-material mt-4" style={{ height: '600px', width: '100%' }}>
                        <AgGridReact
                        agTextCellEditor={true}
                          // onCellValueChanged={(p)=>{console.log(p)}}
                          defaultColDef={this.state.defaultColDef}
                          getRowHeight={this.state.getRowHeight}
                          fullWidthCellRenderer={this.state.fullWidthCellRenderer}
                          stopEditingWhenGridLosesFocus={true}
                          onGridReady={this.onGridReady}
                          columnDefs={this.state.columnDefs}
                          rowData={this.state.rowData}>
                        </AgGridReact>
                    </div>
                  </div>
                </div>
                <div
                  className={classnames("animation-slider-overlay", {
                    show: this.state.ListsOverlayVisible
                  })}
                  onClick={() => this.toggleOverlay(false)}
                />
              </Fragment>
              : null
          }
        </div>

        <div>
          <Modal isOpen={this.state.deleteModal}>
            <ModalHeader>
              Delete Content
            </ModalHeader>
            <ModalBody>
              <h5>This action is permanent !</h5>
              <p> Are you sure you want to remove this List Item.</p>
            </ModalBody>
            <ModalFooter>
              <Button color="secondary" onClick={() => { this.setState({ deleteModal: false }) }}>Cancel</Button>{' '}
              <Button color="primary" onClick={this.deleteEntry}>Delete</Button>
            </ModalFooter>
          </Modal>
        </div>

      </Fragment>
    );
  }
}

export default Lists;